exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".receipt-body[data-v-530c61b8]{background:#f0f0f0;border-radius:10px!important;padding:20px}", ""]);

// exports
